export default "__VITE_ASSET__DWtyMxlW__"